export enum OverFlowTypes {
    HIDDEN = 'hidden',
    AUTO = 'auto',
    SCROLL = 'scroll',
    VISIBLE = 'visible',
}

export enum DSClassNames {
    DSScrollbar = 'ds-scrollbar',
    DSScrollbarInverse = 'ds-scrollbar-inverse',
}

export enum FeatureNames {
    EGV = 'egv',
    SLOTS = 'slots',
    SEARCHCANCEL = 'searchcancel',
}
export enum DSVariant {
    Filled = 'filled',
    Outline = 'outline',
    Flat = 'flat',
    FlatReduced = 'flat-reduced',
}

export enum DSKind {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Success = 'success',
    Utility = 'utility',
}
